import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  country: "Kuwait",
  countryId: 3,
  areas: [],
};

const customerSlice = createSlice({
  name: "country",
  initialState,
  reducers: {
    setAreas: (state, action) => {
      state.areas = action.payload;
    },
  },
});

export const { setAreas } = customerSlice.actions;

export default customerSlice.reducer;
